import { apiClient } from "./client"

export const apiInstance = apiClient

export class ApiInstance {
  constructor() {
    this.instance = apiInstance
  }

  readonly instance: typeof apiInstance
}
